import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { TierProvider } from "@/hooks/useTier";
import GlobalUpgradeListener from "@/components/upgrade/GlobalUpgradeListener";
import LandingPage from "@/pages/LandingPage";
import FeaturedArtists from "@/pages/FeaturedArtists";
import MagazineStorefront from "@/pages/MagazineStorefront";
import IssueDetail from "@/pages/IssueDetail";
import PurchaseSuccess from "@/pages/PurchaseSuccess";
import LivePage from "@/pages/LivePage";
import LiveEventPage from "@/pages/LiveEventPage";
import ArtistProfilePage from "@/pages/ArtistProfilePage";
import SubmissionSharePage from "@/pages/SubmissionSharePage";
import ProfileEditPage from "@/pages/ProfileEditPage";
import CommunityGuidelinesPage from "@/pages/CommunityGuidelinesPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import DashboardPage from "@/pages/DashboardPage";
import SubmitMusicPage from "@/pages/SubmitMusicPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLiveHealthPage from "@/pages/AdminLiveHealthPage";
import AdminCoinReservePage from "@/pages/AdminCoinReservePage";
import AdminCloudinaryStoragePage from "@/pages/AdminCloudinaryStoragePage";
import AdminControlCenterPage from "@/pages/AdminControlCenterPage";
import AdminCoinRushPage from "@/pages/AdminCoinRushPage";
import CoinRushPage from "@/pages/CoinRushPage";
import CreateReelPage from "@/pages/CreateReelPage";
import ReelsFeedPage from "@/pages/ReelsFeedPage";
import AdminArtworkControlCenterPage from "@/pages/AdminArtworkControlCenterPage";
import AdminCommunityPage from "@/pages/AdminCommunityPage";
import AdminContestsPage from "@/pages/AdminContestsPage";
import MembershipPage from "@/pages/MembershipPage";
import MembershipSuccessPage from "@/pages/MembershipSuccessPage";
import FounderClaimPage from "@/pages/FounderClaimPage";
import AdminMembershipCenter from "@/pages/AdminMembershipCenter";
import AdminFeaturePulseAuditPage from "@/pages/AdminFeaturePulseAuditPage";
import AdminContestEditorPage from "@/pages/AdminContestEditorPage";
import AdminContestEntriesPage from "@/pages/AdminContestEntriesPage";
// RGM Contests · Phase 1 — Judging module (feature-flag gated).
import AdminContestJudgingPage from "@/pages/AdminContestJudgingPage";
import JudgeInboxPage from "@/pages/JudgeInboxPage";
import JudgeContestWorkspace from "@/pages/JudgeContestWorkspace";
import SpotlightARWorkspace from "@/pages/SpotlightARWorkspace";
import AdminSpotlightARPage from "@/pages/AdminSpotlightARPage";
import AdminBadgeCatalogPage from "@/pages/AdminBadgeCatalogPage";
import AdminHallOfChampionsPage from "@/pages/AdminHallOfChampionsPage";
// Phase 21.4 Batch 3D — Public Contest Center + Hall of Champions
import ContestsPage from "@/pages/ContestsPage";
import ContestDetailPage from "@/pages/ContestDetailPage";
import EnterContestPage from "@/pages/EnterContestPage";
import MyContestSubmissionsPage from "@/pages/MyContestSubmissionsPage";
import HallOfChampionsPage from "@/pages/HallOfChampionsPage";
import ContestResultPage from "@/pages/ContestResultPage";
import ProducerStatsPage from "@/pages/ProducerStatsPage";
import AdminWaitlist from "@/pages/AdminWaitlist";
import AdminMagazineManager from "@/pages/AdminMagazineManager";
import AdminLiveSettings from "@/pages/AdminLiveSettings";
import TrackPage from "@/pages/TrackPage";
import TrackEditPage from "@/pages/TrackEditPage";
import ExplorePage from "@/pages/ExplorePage";
import CommunityPage from "@/pages/CommunityPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import NotificationsPage from "@/pages/NotificationsPage";
import ChartsPage from "@/pages/ChartsPage";
import DiscoveryFeedPage from "@/pages/DiscoveryFeedPage";
import PlaylistsPage from "@/pages/PlaylistsPage";
import PlaylistDetailPage from "@/pages/PlaylistDetailPage";
import JoinPage from "@/pages/JoinPage";
import HowToGetFeaturedPage from "@/pages/HowToGetFeaturedPage";
import DiscoveryHomePage from "@/pages/DiscoveryHomePage";
import ReferralsPage from "@/pages/ReferralsPage";
import CrewsPage from "@/pages/CrewsPage";
import CrewDetailPage from "@/pages/CrewDetailPage";
import ClubDetailPage from "@/pages/ClubDetailPage";
import BusinessHubPage from "@/pages/BusinessHubPage";
import BusinessDetailPage from "@/pages/BusinessDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import CoursesPage from "@/pages/CoursesPage";
import MonetizationPage from "@/pages/MonetizationPage";
import WalletPage from "@/pages/WalletPage";
import PayoutsPage from "@/pages/PayoutsPage";
import AdminPayoutsPage from "@/pages/AdminPayoutsPage";
import AdminAuditPage from "@/pages/AdminAuditPage";
import StripeConnectReturnPage from "@/pages/StripeConnectReturnPage";
import StripeConnectRefreshPage from "@/pages/StripeConnectRefreshPage";
import AdminMediaPage from "@/pages/AdminMediaPage";
import PayoutPolicyPage from "@/pages/PayoutPolicyPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import DmcaPolicyPage from "@/pages/DmcaPolicyPage";
import MonetizationPolicyPage from "@/pages/MonetizationPolicyPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import DeleteAccountPage from "@/pages/DeleteAccountPage";
import GlobalFooter from "@/components/GlobalFooter";
import AdminServiceStatusPage from "@/pages/AdminServiceStatusPage";
import AdminRuntimeStatusPage from "@/pages/AdminRuntimeStatusPage";
import AdminShareCardControlPage from "@/pages/AdminShareCardControlPage";
import AdminMenuOrganizerPage from "@/pages/AdminMenuOrganizerPage";
import AdminBeatsPage from "@/pages/AdminBeatsPage";
import AdminReferralsPage from "@/pages/AdminReferralsPage";
import AdminAffiliatePage from "@/pages/AdminAffiliatePage";
import FanVotePage from "@/pages/FanVotePage";
import FanVoteEntryPage from "@/pages/FanVoteEntryPage";
import FanVoteVerifyPage from "@/pages/FanVoteVerifyPage";
import AdminFanVotePage from "@/pages/AdminFanVotePage";
import AffiliateDashboardPage from "@/pages/AffiliateDashboardPage";
// iter_226 · Phase 22 — Direct-to-Consumer Singles Store (dark launch)
import SinglesStorePage from "@/pages/SinglesStorePage";
import SingleDetailPage from "@/pages/SingleDetailPage";
import SellThisTrackPage from "@/pages/SellThisTrackPage";
import MySinglesLibrary from "@/pages/MySinglesLibrary";
import AdminSinglesStorePage from "@/pages/AdminSinglesStorePage";
import ReferralLeaderboardPage from "@/pages/ReferralLeaderboardPage";
import ReportsPage from "@/pages/ReportsPage";
import ReportDetailPage from "@/pages/ReportDetailPage";
import AdminReportsPage from "@/pages/AdminReportsPage";
import AdminSpotlightAuditPage from "@/pages/AdminSpotlightAuditPage";
import AdminPlayCountAuditPage from "@/pages/AdminPlayCountAuditPage";
import WinnersNetworkPage from "@/pages/WinnersNetworkPage";
import SubmitBeatPage from "@/pages/SubmitBeatPage";
import BeatsMarketplacePage from "@/pages/BeatsMarketplacePage";
import BeatDetailPage from "@/pages/BeatDetailPage";
import BeatPlaylistsPage from "@/pages/BeatPlaylistsPage";
import BeatPlaylistDetailPage from "@/pages/BeatPlaylistDetailPage";
import ShufflePage from "@/pages/ShufflePage";
import ShuffleRadioPlayerPage from "@/pages/ShuffleRadioPlayerPage";
import LicensedBeatsPage from "@/pages/LicensedBeatsPage";
import NotificationSettingsPage from "@/pages/NotificationSettingsPage";
import AdminNotificationsHealthPage from "@/pages/AdminNotificationsHealthPage";
import ProducerDashboardPage from "@/pages/ProducerDashboardPage";
import AdminHeroSlidesPage from "@/pages/AdminHeroSlidesPage";
import CreatorHubPage from "@/pages/CreatorHubPage";
import StudioProjectDetailsPage from "@/pages/StudioProjectDetailsPage";
import StudioPage from "@/pages/StudioPage";
import StudioSessionPage from "@/pages/StudioSessionPage";
import StudioCollaborationsPage from "@/pages/StudioCollaborationsPage";
import OfficialProfilePage from "@/pages/OfficialProfilePage";
import PublicLeaderboardPage from "@/pages/PublicLeaderboardPage";
import SpotlightPage from "@/pages/SpotlightPage";
import VirtualGiftsPage from "@/pages/VirtualGiftsPage";
import SupportPage from "@/pages/SupportPage";
import AdminSupportPage from "@/pages/AdminSupportPage";
import CoinReturnPage from "@/pages/CoinReturnPage";
import EarningsPage from "@/pages/EarningsPage";
import TopGiftersPage from "@/pages/TopGiftersPage";
import LiveRoomsListPage from "@/pages/LiveRoomsListPage";
import LiveRoomPage from "@/pages/LiveRoomPage";
import WhatsNewToast from "@/components/WhatsNewToast";
import StripeHealthBanner from "@/components/StripeHealthBanner";
import GetTheAppBanner from "@/components/GetTheAppBanner";
import AppModeBlocked from "@/components/AppModeBlocked";
import { initAppMode, isAppMode, isAppAllowedPath } from "@/lib/appMode";
import { TutorialProvider } from "@/components/tutorial/TutorialProvider";
import TutorialOverlay from "@/components/tutorial/TutorialOverlay";
import FloatingHelpButton from "@/components/tutorial/FloatingHelpButton";
import ErrorBoundary from "@/components/ErrorBoundary";
import { PlayerProvider } from "@/components/player/PlayerProvider";
import GlobalMiniPlayer from "@/components/player/GlobalMiniPlayer";
import ShuffleRadioAnalytics from "@/components/player/ShuffleRadioAnalytics";
import PresenceHeartbeat from "@/components/PresenceHeartbeat";
import "@/App.css";

/**
 * 🏠 Phase 9 — Home flip
 * Authed users land on /home (the music + activity feed); anonymous
 * visitors still see the marketing LandingPage at /. Decision is sync
 * because the session token lives in localStorage — no flash of the
 * wrong page on refresh.
 */
function RootRoute() {
  if (typeof window !== "undefined" && localStorage.getItem("session_token")) {
    return <Navigate to="/home" replace />;
  }
  return <LandingPage />;
}

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment (not query params) for session_id - process BEFORE any routing
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  if (isAppMode() && !isAppAllowedPath(location.pathname)) {
    return <AppModeBlocked />;
  }

  return (
    <>
    <Routes>
      <Route path="/" element={<RootRoute />} />
      <Route path="/home" element={<DiscoveryHomePage />} />
      <Route path="/explore" element={<ExplorePage />} />
      <Route path="/charts" element={<ChartsPage />} />
      <Route path="/discover" element={<DiscoveryHomePage />} />
      <Route path="/discover/feed" element={<DiscoveryFeedPage />} />
      <Route path="/playlists" element={<PlaylistsPage />} />
      <Route path="/playlist/:playlistId" element={<PlaylistDetailPage />} />
      <Route path="/playlists/:playlistId" element={<PlaylistDetailPage />} />
      <Route path="/community" element={<CommunityPage />} />
      <Route path="/crews" element={<CrewsPage />} />
      {/* Phase 19.0.1 — /groups and /clubs alias the unified Crews hub
          with a preselected tab. Lets BackButton fallbacks ("Group → /groups",
          "Club → /clubs") land on a real page instead of a 404. */}
      <Route path="/groups" element={<CrewsPage defaultTab="group" />} />
      <Route path="/clubs" element={<CrewsPage defaultTab="club" />} />
      <Route path="/crews/:crewId" element={<CrewDetailPage />} />
      <Route path="/clubs/:clubId" element={<ClubDetailPage />} />
      <Route path="/business" element={<BusinessHubPage />} />
      <Route path="/business/:businessId" element={<BusinessDetailPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/courses" element={<CoursesPage />} />
      <Route path="/promote" element={<MonetizationPage />} />
      <Route path="/membership" element={<MembershipPage />} />
      <Route path="/membership/success" element={<MembershipSuccessPage />} />
      <Route path="/founder/claim/:token" element={<FounderClaimPage />} />
      <Route path="/admin/memberships" element={<AdminMembershipCenter />} />
      <Route path="/admin/feature-pulse-audit" element={<AdminFeaturePulseAuditPage />} />
      <Route path="/join/:slug" element={<JoinPage />} />
      <Route path="/featured" element={<FeaturedArtists />} />
      <Route path="/leaderboard/today" element={<PublicLeaderboardPage />} />
      <Route path="/leaderboard" element={<PublicLeaderboardPage />} />
      <Route path="/spotlight" element={<SpotlightPage />} />
      <Route path="/virtual-gifts" element={<VirtualGiftsPage />} />
      <Route path="/gifts" element={<VirtualGiftsPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/help" element={<SupportPage />} />
      <Route path="/admin/support" element={<AdminSupportPage />} />
      <Route path="/magazine" element={<MagazineStorefront />} />
      <Route path="/magazine/issue/:slug" element={<IssueDetail />} />
      <Route path="/magazine/purchase-success" element={<PurchaseSuccess />} />
      <Route path="/live" element={<LivePage />} />
      <Route path="/live/events/:eventId" element={<LiveEventPage />} />
      <Route path="/artist/:user_id" element={<ArtistProfilePage />} />
      <Route path="/track/:submission_id" element={<TrackPage />} />
      <Route path="/track/:submission_id/edit" element={<TrackEditPage />} />
      <Route path="/submission/:submission_id" element={<SubmissionSharePage />} />
      <Route path="/profile/edit" element={<ProfileEditPage />} />
      <Route path="/settings/profile" element={<ProfileEditPage />} />
      <Route path="/community-guidelines" element={<CommunityGuidelinesPage />} />
      <Route path="/how-to-get-featured" element={<HowToGetFeaturedPage />} />
      <Route path="/referrals" element={<ReferralsPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/studio" element={<StudioPage />} />
      <Route path="/studio/collaborations" element={<StudioCollaborationsPage />} />
      <Route path="/studio/session/:sessionId" element={<StudioSessionPage />} />
      <Route path="/studio/project/:projectId" element={<StudioProjectDetailsPage />} />
      <Route path="/wallet" element={<WalletPage />} />
      <Route path="/payouts" element={<PayoutsPage />} />
      <Route path="/payouts/connect/return" element={<StripeConnectReturnPage />} />
      <Route path="/payouts/connect/refresh" element={<StripeConnectRefreshPage />} />
      <Route path="/admin/payouts" element={<AdminPayoutsPage />} />
      <Route path="/admin/audit" element={<AdminAuditPage />} />
      <Route path="/admin/media" element={<AdminMediaPage />} />
      <Route path="/payout-policy" element={<PayoutPolicyPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsOfServicePage />} />
      <Route path="/terms-of-service" element={<TermsOfServicePage />} />
      <Route path="/dmca" element={<DmcaPolicyPage />} />
      <Route path="/copyright" element={<DmcaPolicyPage />} />
      <Route path="/monetization-policy" element={<MonetizationPolicyPage />} />
      <Route path="/refund-policy" element={<RefundPolicyPage />} />
      <Route path="/delete-account" element={<DeleteAccountPage />} />
      <Route path="/account-deletion" element={<DeleteAccountPage />} />
      <Route path="/coins/return" element={<CoinReturnPage />} />
      <Route path="/earnings" element={<EarningsPage />} />
      <Route path="/leaderboard" element={<TopGiftersPage />} />
      <Route path="/coin-rush" element={<CoinRushPage />} />
      {/* RGM Reels — Phase 1B Create Reel experience + Phase 1C
          minimum public viewing surface. */}
      <Route path="/create/reel" element={<CreateReelPage />} />
      <Route path="/reels/create" element={<CreateReelPage />} />
      <Route path="/reels" element={<ReelsFeedPage />} />
      <Route path="/beams" element={<LiveRoomsListPage />} />
      <Route path="/beams/:roomId" element={<LiveRoomPage />} />
      <Route path="/submit" element={<SubmitMusicPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/control-center" element={<AdminControlCenterPage />} />
      <Route path="/admin/coin-rush" element={<AdminCoinRushPage />} />
      <Route path="/admin/artwork" element={<AdminArtworkControlCenterPage />} />
      <Route path="/admin/community" element={<AdminCommunityPage />} />
      {/* Phase 21.4 Batch 3D — 🏆 Public Contest Center + Hall of Champions.
          Feature-flag gated at the API — pages render "Coming Soon" placeholder
          when contests.enabled === false. */}
      <Route path="/contests" element={<ContestsPage />} />
      <Route path="/contests/my" element={<MyContestSubmissionsPage />} />
      <Route path="/contests/:slug" element={<ContestDetailPage />} />
      <Route path="/contests/:slug/enter" element={<EnterContestPage />} />
      <Route path="/contests/:slug/results/:entryId" element={<ContestResultPage />} />
      <Route path="/hall-of-champions" element={<HallOfChampionsPage />} />
      {/* Phase 21.4 Batch 3C — 🏆 Contest Center admin UI */}
      <Route path="/admin/contests" element={<AdminContestsPage />} />
      <Route path="/admin/contests/new" element={<AdminContestEditorPage />} />
      <Route path="/admin/contests/:contestId" element={<AdminContestEditorPage />} />
      <Route path="/admin/contests/:contestId/entries" element={<AdminContestEntriesPage />} />
      <Route path="/admin/contests/:contestId/judging" element={<AdminContestJudgingPage />} />
      <Route path="/judge" element={<JudgeInboxPage />} />
      <Route path="/judge/:contestId" element={<JudgeContestWorkspace />} />
      {/* Phase 2 — Spotlight A&R Judging (preview only) */}
      <Route path="/spotlight-ar/:spotlightId" element={<SpotlightARWorkspace />} />
      <Route path="/admin/spotlight/:spotlightId/ar-review" element={<AdminSpotlightARPage />} />
      <Route path="/admin/badge-catalog" element={<AdminBadgeCatalogPage />} />
      <Route path="/admin/hall-of-champions" element={<AdminHallOfChampionsPage />} />
      {/* Phase 19.5 — Producer Statistics dashboard (own + public) */}
      <Route path="/producer/stats" element={<ProducerStatsPage />} />
      <Route path="/producer/:producerId/stats" element={<ProducerStatsPage />} />
      <Route path="/admin/waitlist" element={<AdminWaitlist />} />
      <Route path="/admin/magazine" element={<AdminMagazineManager />} />
      <Route path="/admin/live" element={<AdminLiveSettings />} />
      <Route path="/admin/live-health" element={<AdminLiveHealthPage />} />
      <Route path="/admin/coin-reserve" element={<AdminCoinReservePage />} />
      <Route path="/admin/cloudinary" element={<AdminCloudinaryStoragePage />} />
      <Route path="/admin/service-status" element={<AdminServiceStatusPage />} />
      <Route path="/admin/runtime-status" element={<AdminRuntimeStatusPage />} />
      <Route path="/admin/creative/share-cards" element={<AdminShareCardControlPage />} />
      <Route path="/admin/creative/menu-organizer" element={<AdminMenuOrganizerPage />} />
      <Route path="/admin/beats" element={<AdminBeatsPage />} />
      <Route path="/admin/referrals" element={<AdminReferralsPage />} />
      <Route path="/admin/affiliates" element={<AdminAffiliatePage />} />
      <Route path="/fan-vote" element={<FanVotePage />} />
      <Route path="/fan-vote/entry/:entryId" element={<FanVoteEntryPage />} />
      <Route path="/fan-vote/verify" element={<FanVoteVerifyPage />} />
      <Route path="/admin/fan-vote" element={<AdminFanVotePage />} />
      <Route path="/affiliate" element={<AffiliateDashboardPage />} />
      <Route path="/referrals/leaderboard" element={<ReferralLeaderboardPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/reports/:reportId" element={<ReportDetailPage />} />
      {/* RGM Studio Official Community & A&R Hub — R1 Foundation. */}
      <Route path="/rgm-studio" element={<OfficialProfilePage />} />
      <Route path="/admin/reports" element={<AdminReportsPage />} />
      <Route path="/admin/spotlight-audit" element={<AdminSpotlightAuditPage />} />
      <Route path="/admin/play-counts" element={<AdminPlayCountAuditPage />} />
      <Route path="/winners" element={<WinnersNetworkPage />} />
      <Route path="/creator-hub" element={<CreatorHubPage />} />
      <Route path="/submit-beat" element={<SubmitBeatPage />} />
      <Route path="/submit-beat/:beatId" element={<SubmitBeatPage />} />
      <Route path="/beats" element={<BeatsMarketplacePage />} />
      <Route path="/beats/:beatId" element={<BeatDetailPage />} />
      <Route path="/beat-playlists" element={<BeatPlaylistsPage />} />
      <Route path="/beat-playlists/:playlistId" element={<BeatPlaylistDetailPage />} />
      <Route path="/shuffle" element={<ShufflePage />} />
      <Route path="/shuffle/radio-player" element={<ShuffleRadioPlayerPage />} />
      {/* Phase 20.8 — Buyer Library */}
      <Route path="/library/beats" element={<LicensedBeatsPage />} />
      <Route path="/my-licensed-beats" element={<LicensedBeatsPage />} />
      {/* Phase 20.12 — Notification preferences */}
      <Route path="/settings/notifications" element={<NotificationSettingsPage />} />
      <Route path="/admin/notifications-health" element={<AdminNotificationsHealthPage />} />
      <Route path="/rgm-shuffle" element={<ShufflePage />} />
      {/* Phase 20.6.1 — Feed-only twin of /shuffle (no Radio Hero) */}
      <Route path="/reposts" element={<ShufflePage mode="reposts" />} />
      <Route path="/rgm-reposts" element={<ShufflePage mode="reposts" />} />
      <Route path="/producer" element={<ProducerDashboardPage />} />
      <Route path="/admin/hero-slides" element={<AdminHeroSlidesPage />} />

      {/* iter_226 · Phase 22 — Singles Store (kill switch: singles.enabled).
          Backend blocks public browse/preview/checkout with 503 while
          disabled; admins/founders bypass so we can verify in dark
          mode without exposing purchases to regular artists. */}
      <Route path="/singles" element={<SinglesStorePage />} />
      <Route path="/singles/:listing_id" element={<SingleDetailPage />} />
      <Route path="/singles/sell/:submission_id" element={<SellThisTrackPage />} />
      <Route path="/library/singles" element={<MySinglesLibrary />} />
      <Route path="/admin/singles-store" element={<AdminSinglesStorePage />} />
    </Routes>
    <GlobalFooter />
    </>
  );
}

function App() {
  const appMode = initAppMode();
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <TierProvider>
            <PlayerProvider>
              <TutorialProvider>
                {!appMode && <GetTheAppBanner />}
                {!appMode && <StripeHealthBanner />}
                <AppRouter />
                {!appMode && <WhatsNewToast />}
                {/* Phase 15.1 — Onboarding + Tutorial system */}
                {!appMode && <TutorialOverlay />}
                {!appMode && <FloatingHelpButton />}
                {/* Phase 15.6J — Persistent global mini player */}
                {!appMode && <GlobalMiniPlayer />}
                {/* Phase 20.6 — Shuffle Radio analytics tracker (fires play/skip/complete) */}
                <ShuffleRadioAnalytics />
                {/* iter_191 — Global 402 upgrade listener */}
                <GlobalUpgradeListener />
                {/* iter_195 — Foreground presence heartbeat (canonical) */}
                <PresenceHeartbeat />
              </TutorialProvider>
            </PlayerProvider>
          </TierProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;